<template>
  <div class="shop">
    <div class="top">
      <el-input
        class="search input"
        size="small"
        v-model="form.store_mobile"
        placeholder="店铺手机号"
        clearable
      ></el-input>
      <el-input
        class="search input"
        size="small"
        v-model="form.goods_name"
        placeholder="商品名称"
        clearable
      ></el-input>
      <el-button
        class="search"
        size="small"
        type="primary"
        @click="searchOrderData"
        >搜索</el-button
      >
    </div>
    <el-table
      :data="tableData"
      max-height="720"
      :cell-style="tc"
      :header-cell-style="tccolor"
      v-loading="loading"
    >
      <el-table-column label="序号" prop="goods_id"></el-table-column>
      <el-table-column
        label="上架时间"
        prop="created_at"
      ></el-table-column>
      <el-table-column label="店铺手机号" prop="shop_mobie"></el-table-column>
      <el-table-column label="商品名称" prop="goods_name"></el-table-column>
      <el-table-column label="状态" prop="goods_status_name"></el-table-column>
      <el-table-column label="商品主图" width="180">
        <template slot-scope="scope">
          <div class="img">
            <img
              :key="scope.row.goods_id"
              style="width:100px;height:100px"
              :src="scope.row.img_url ? scope.row.img_url : errorImg"
              alt
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="售价" prop="sort_discount_price"></el-table-column>
      <el-table-column label="共享收益" prop="sort_share_income"></el-table-column>
      <el-table-column label="操作" fixed="right" width="160">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="goGoodsDetail(scope.row.goods_id)"
            >详情</el-button
          >
          <el-button
            size="mini"
            @click="deleteFn(scope.row.goods_id)"
            >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24">
      <div class="pagination">
        <el-pagination
          background
          @current-change="pageChange"
          :current-page="form.page"
          :page-size="form.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-col>
  </div>
</template>

<script>
import errorImg from '@/assets/images/error_img.png'
import { deleteHotGoods, getHotGoodsList } from '@/api/nearbyHot'
export default {
  components: {},
  data() {
    return {
      loading: false,
      tableData: [],
      isShowOrderremark: false,
      total: 0,
      errorImg,
      form: {
        store_mobile:'',
        goods_name:'',
        page: 1,
        size: 20,
        is_export: '',
      },
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    //删除商品
    deleteFn(goods_id){
      this.$confirm('确认删除该商品？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
          .then(() => {
            this.deleteHotGoodsFn(goods_id)
          })
          .catch(() => {
            console.log('cancel')
          })
    },
    async deleteHotGoodsFn(goods_id) {
      let res = await deleteHotGoods({goods_id})
      if (res.code === 10000) {
        this.$message.success(res.message)
        this.getListData()
      } else {
        this.$message.error(res.message)
      }
    },
    //搜索
    searchOrderData() {
      this.form.page = 1
      this.getListData()
    },
    //获取列表数据
    async getListData() {
      let url = `page=${this.form.page}&mobile=${this.form.store_mobile}&goods_name=${this.form.goods_name}&is_export=${this.form.is_export}&size=${this.form.size}`
      let res = await getHotGoodsList(url)
      if (res.code === 10000) {
        if (this.form.is_export == 1) {
          this.form.is_export = 0
          this.loading = true
          return
        } else {
          this.total = res.data.total
          this.tableData = res.data.data
        }
      } else {
        this.form.is_export = 0
        this.$message.error(res.message)
      }
    },

    // 分页设置
    pageChange(page) {
      this.form.page = page
      //获取更多数据
      this.getListData()
    },
    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    },

    //前往商品详情
    goGoodsDetail(goods_id) {
      this.$router.push({
        path: './nearbyHotDetail',
        query: { goods_id }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.shop {
  padding: 20px;
  .top {
    margin-bottom: 20px;
    .search {
      margin-left: 12px;
    }
    .input {
      width: 130px;
    }
    .guodu {
      line-height: 30px;
    }
  }
  .pagination {
    margin-top: 12px;
  }
  .align {
    text-align: center;
    padding-bottom: 20px;
  }
  .demo-ruleForm {
    padding: 20px;
    .remarkarea {
      padding-right: 30px;
      margin-top: 20px;
    }
  }
  .remark {
    padding: 20px;
    .note {
      color: #666666;
      margin-bottom: 12px;
    }
    .btn-info {
      text-align: center;
    }
  }
}
</style>
